module.exports = __webpack_public_path__ + "img/filters.62e4383f.svg";